export const mobileLength = (code) => {
	if (code === '+91') {
		return 10
	}

	return 15
}
